import React from "react"
import { MenuItem, TextField, Box, TextFieldProps } from "@mui/material"

import SystemConfigurationDialog from "components/Dialogs/SystemConfigurationDialog"

import useOuterLengthsBySystemConfiguration from "@secureo/common/hooks/cylinderConfigurations/useOuterLengthsBySystemConfiguration"

import { OuterLengthsBySystem } from "@secureo/common/typings/Product"

const SystemAndOuterLengthConfigurationInput = ({
	outerLengthsBySystem,
	selectedSystem,
	selectedOuterLength,
	onSystemChange,
	onOuterLengthChange,
	systemConfigurationToolTip,
	disabled,
	margin = "normal",
}: Props) => {
	const { systemInputProps, outerLengthInputProps, availableSystems, availableOuterLengths } =
		useOuterLengthsBySystemConfiguration(
			outerLengthsBySystem,
			selectedSystem,
			selectedOuterLength,
			onSystemChange,
			onOuterLengthChange,
		)

	return (
		<Box mt={1}>
			<div style={{ display: "flex", alignItems: "center" }}>
				<div style={{ width: "50%" }}>
					<Box style={{ display: "flex", alignItems: "center" }}>
						<SystemConfigurationDialog
							systemConfigurationToolTip={systemConfigurationToolTip}
						/>
					</Box>
					<TextField
						id="system"
						label="Ausführung"
						value={systemInputProps.value}
						onChange={(e) => systemInputProps.onChange(null, e.target.value)}
						margin={margin}
						variant="filled"
						select
						fullWidth
						disabled={disabled}
					>
						{availableSystems.map((system) => (
							<MenuItem key={system} value={system}>
								{system}
							</MenuItem>
						))}
					</TextField>
				</div>
				<Box ml={1} style={{ width: "50%" }}>
					<Box mr={-1}>
						<strong>Außenlänge wählen</strong>
					</Box>
					<TextField
						id="outerLength"
						label="Außenlänge"
						{...outerLengthInputProps}
						margin={margin}
						variant="filled"
						select
						fullWidth
						disabled={disabled}
					>
						{availableOuterLengths.map((outerLength) => (
							<MenuItem key={outerLength} value={outerLength}>
								{outerLength} mm
							</MenuItem>
						))}
					</TextField>
				</Box>
			</div>
		</Box>
	)
}

interface Props {
	outerLengthsBySystem: OuterLengthsBySystem
	selectedSystem: string
	selectedOuterLength: number
	onSystemChange: (selectedSystem: string) => void
	onOuterLengthChange: (selectedOuterLength: number) => void
	systemConfigurationToolTip?: string
	disabled?: boolean
	margin?: TextFieldProps["margin"]
}

export default SystemAndOuterLengthConfigurationInput
